<script lang="ts">
export default {
    name: 'VueRadioButton',
}
</script>

<script setup lang="ts">
import { computed } from "vue";

// Props
const props = defineProps({
    id: {
        type: String,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    value: {
        required: true
    },
    isInline: {
        default: false
    },
    isAdmin: {
        default: true
    },
    hasLabel: {
        default: true
    },
    labelText: {
        type: String,
        required: true
    },
    labelStyle: {
        type: String
    },
    labelClasses: {
        type: String
    },
    modelValue: {},
    selected: {
        type: Boolean,
        default: false
    },
    isRequired: {
        type: Boolean,
        default: false
    }
});

// Computed methods
// Setting label classes based on isAdmin, hasLabel, and labelStyle props
const setLabelClasses = computed(() => {
    const hasLabel = props.hasLabel,
        hasStyle = props.labelStyle?.toLowerCase();

    return {
        'sr-only': !hasLabel,
        'text-xs font-normal': props.isAdmin && hasStyle === 'light',
        'rd-text-xs rd-font-normal': !props.isAdmin && hasStyle === 'light'
    }
});

// Setting position classes based on isAdmin and isInline props
const setPositionClasses = computed(() => {
    let classes: any;

    if (props.isAdmin) {
        props.isInline ? classes = 'items-center inline-flex' : classes = 'items-center flex';
    }
    else {
        props.isInline ? classes = 'rd-items-center rd-inline-flex rd-relative' : classes = 'rd-items-center rd-flex rd-relative';
    }

    return classes;
});

const setRadioClasses = computed(() => {
    return {
        'rd-relative': !props.isAdmin,
        'form-radio form-radio-green': props.isAdmin
    }
});
</script>

<template>
    <div :class="setPositionClasses">
        <input type="radio" :id="id" :name="name" :class="setRadioClasses" :checked="selected" :value="value"
            @change="$emit('update:modelValue', value)" />

        <label v-if="hasLabel" :for="id"
            :class="[setLabelClasses, labelClasses, isAdmin ? 'mb-0 ml-2.5' : 'rd-ml-2.5 !rd-mb-0']"
            v-html="labelText"></label>
    </div>
</template>
